"use client"

interface VisualSiloContentProps {
  className?: string
}

export function VisualSiloContent({ className = "" }: VisualSiloContentProps) {
  return (
    <div className={`w-full h-full flex flex-col items-center justify-center p-8 ${className}`}>
      <div className="max-w-2xl text-center space-y-6">
        <h2 className="text-3xl font-bold">VisualSilo</h2>
        <p className="text-md text-gray-600">
          Website / App design and development.
        </p>
        <div className="space-y-8">
        <p className="text-lg font-medium text-gray-600">
          Do you love Raintree Chinese Medicine and Acupuncture website?
        </p>
          <p className="text-gray-700">
            VisualSilo specializes in creating beautiful, functional websites and applications for healthcare professionals and other businesses.
          </p>
        </div>
        <div className="flex flex-col sm:flex-row gap-4 justify-center items-center pt-8">
          <a
            href="https://visualsilo.com"
            target="_blank"
            rel="noopener noreferrer"
            className="px-6 py-2 bg-[#231f20] text-white rounded-md hover:bg-[#3a3536] transition-colors"
          >
            Visit VisualSilo
          </a>
          <a
            href="mailto:hello@visualsilo.com"
            className="px-6 py-2 border border-[#231f20] text-[#231f20] rounded-md hover:bg-[#231f20] hover:text-white transition-colors"
          >
            Contact Us
          </a>
        </div>
      </div>
    </div>
  )
}

